export default __webpack_public_path__ + "media/match-therapist-bg.bdd34496.png";